import { io } from 'socket.io-client';
import Cookies from 'js-cookie';

let webSocketURL = window.localStorage.getItem('API_URL') || process.env.REACT_APP_API_ENDPOINT || '';
const currentToken = Cookies.get('access_token');
export const socketClient = io(webSocketURL, {
    path: '/ws/',
    extraHeaders: {
        Authorization: currentToken ? `Bearer ${currentToken}` : '',
    },
});

export const updateSocketToken = (token) => {
    if (token) {
        socketClient.auth = { token: `Bearer ${token}` };
        socketClient.io.opts.extraHeaders = {
            Authorization: `Bearer ${token}`,
        };
    } else {
        socketClient.auth = { token: '' };
        socketClient.io.opts.extraHeaders = {};
    }

    if (socketClient.connected) {
        socketClient.disconnect();
    }
    socketClient.connect();
};
